﻿import UserApi from '../../api/UserApi';


export function sendUserNotFoundForm(name:string, brokerFirm: string, email:string, phoneNumber:string, organizationNumber: string, message:string):Promise<void>{
    return UserApi.sendUserNotFoundForm(name, brokerFirm, email, phoneNumber, organizationNumber, message);
}